"use client";

export default function Paging({ onLoadMore, hasNext, totalElements, data, isLoading = false }) {
    const showLoadMore =
        hasNext === false ||
        totalElements === data?.length;

    const handleClickLoadMore = () => {
        if (isLoading) return;
        onLoadMore();
    };

    return (
        <div className="row services">
            {showLoadMore ? (
                ""
            ) : (
                <div className="service-item text-center wow zoomIn mb-0">
                    <hr className="w-full  border-t-2 border-gray-300" />
                    <span
                        onClick={handleClickLoadMore}
                        className={`btn btn-brand m-3 align-items-center ${isLoading ? "disabled" : ""}`}
                        aria-disabled={isLoading}
                    >
                        {isLoading ? "Đang tải..." : "Xem thêm"}
                    </span>
                </div>
            )}
        </div>
    );
}
